import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "corner.rounded.16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fillRule: "evenodd", fill: "currentColor" },
        React.createElement("path", { d: "M8.75 2.75H14V14H2.75V8.75a6 6 0 016-6z", fillOpacity: 0.15 }),
        React.createElement("path", { d: "M14 2v1.5H8.75a5.25 5.25 0 00-5.246 5.034L3.5 8.75V14H2V8.75a6.75 6.75 0 016.513-6.746L8.75 2H14z", fillRule: "nonzero" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
